import { StepMode } from '../../framework/models/StepMode';
import { ScatterPlotSeriesConfiguration } from '../../models';


export class ChartByIdentifierSeriesConfiguration extends ScatterPlotSeriesConfiguration {
    hasMin: boolean;
    hasMax: boolean;
    stepped?: StepMode;

    constructor(guid, color, symbol) {
        super(guid, color, symbol);
        this.stepped = StepMode.nothing;
    }
}
